import React from "react";
import { FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { HiLocationMarker } from "react-icons/hi";
import { Link } from "react-router-dom";
import Logo from "../../asset/footerlogo.png";
import "./Footer.css";

const Footer = () => (
  <footer className="site-footer">
    <div className="site-footer__content">
      <section className="site-footer__brand">
        <Link to="/" aria-label="Hardcoats home">
          <img src={Logo} alt="Hardcoats" className="site-footer__logo" />
        </Link>
        <p>
          A trusted partner in precision engineering, advanced coatings and
          high-performance sealing solutions for demanding industries.
        </p>
        <div className="site-footer__socials" aria-label="Social media">
          <a href="https://www.linkedin.com/company/hardcoats-india-pvt-ltd/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
          <a href="https://www.instagram.com/hardcoatsindia/" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
          <a href="https://wa.me/919920336630" target="_blank" rel="noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
        </div>
      </section>

      <nav className="site-footer__column" aria-label="Footer navigation">
        <h2>Navigate</h2>
        <Link to="/">Home</Link>
        <Link to="/aboutus">About</Link>
        <Link to="/products">Products</Link>
        <Link to="/capabilities">Capabilities</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/code-of-conduct">Code of Conduct</Link>
      </nav>

      <nav className="site-footer__column" aria-label="Product links">
        <h2>Products</h2>
        <Link to="/products">All Products</Link>
        <Link to="/indigenously-developed-assemblies">Indigenously Developed Assemblies</Link>
        <Link to="/coating-and-plating">Coating &amp; Plating</Link>
        <Link to="/precision-component">Precision Components</Link>
        <Link to="/assemblies">Assemblies</Link>
      </nav>

      <nav className="site-footer__column" aria-label="Legal links">
        <h2>Legal</h2>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/cookie-policy">Cookie Policy</Link>
        <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
      </nav>

      <section className="site-footer__column site-footer__contact">
        <h2>Get in touch</h2>
        <a href="mailto:sales@hardcoatsindia.com"><IoMdMail /> sales@hardcoatsindia.com ↗</a>
        <a href="mailto:info@hardcoatsindia.com"><IoMdMail /> info@hardcoatsindia.com ↗</a>
        <a href="tel:+918655016069"><IoCall /> (+91) 86550 16069</a>
        <a href="tel:+918655036068"><IoCall /> (+91) 86550 36068</a>
        <p><HiLocationMarker /> Survey No 16/1, Laxmi Baug N.H-8, Opp. Dara&apos;s Dhaba, Kashimira, Mira Road (E), Thane 401107, India.</p>
      </section>
    </div>

    <div className="site-footer__bottom">
      <p>© {new Date().getFullYear()} Hardcoats India Pvt. Ltd. All rights reserved.</p>
      <p>Designed &amp; built for Hardcoats.</p>
    </div>
  </footer>
);

export default Footer;
